/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
export const enum LogLevel {
  trace = 'trace',
  debug = 'debug',
  info = 'info',
  warn = 'warn',
  error = 'error',
  fatal = 'fatal',
}

const logLevelNumber = {
  [LogLevel.trace]: 0,
  [LogLevel.debug]: 1,
  [LogLevel.info]: 2,
  [LogLevel.warn]: 3,
  [LogLevel.error]: 4,
  [LogLevel.fatal]: 5,
};

export function resolveLevel(level: string): number {
  const lowerLevel = level.toLowerCase();
  if (Object.keys(logLevelNumber).includes(lowerLevel)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (logLevelNumber as any)[lowerLevel];
  }
  return -1;
}
export interface LoggerTransport {
  write(level: LogLevel, fields: { [key: string]: any }, msg: string, ...args: any[]): void;
}
export interface LoggerOptions {
  transports: {
    //// level: default info;
    level?: LogLevel;
    transport: LoggerTransport;
  }[];
}
export class Logger {
  constructor(private _opts: LoggerOptions) {}

  private _log(level: LogLevel, fields: any, msg: string, ...args: any[]): void {
    const lvlNumber = resolveLevel(level);
    for (const trans of this._opts.transports) {
      if (lvlNumber >= resolveLevel(trans.level ?? LogLevel.info)) {
        trans.transport.write(level, fields, msg, ...args);
      }
    }
  }
  trace(fields: object, msg: string, ...args: any[]): void;
  trace(msg: string, ...args: any[]): void;
  trace(): void {
    if (typeof arguments[0] === 'string') {
      const fields = {};
      const msg = arguments[0];
      this._log(LogLevel.trace, fields, msg, ...[...arguments].splice(1));
    } else {
      const fields = arguments[0];
      const msg = arguments[1];
      this._log(LogLevel.trace, fields, msg, ...[...arguments].splice(2));
    }
  }
  debug(fields: object, msg: string, ...args: any[]): void;
  debug(msg: string, ...args: any[]): void;
  debug(): void {
    if (typeof arguments[0] === 'string') {
      const fields = {};
      const msg = arguments[0];
      this._log(LogLevel.debug, fields, msg, ...[...arguments].splice(1));
    } else {
      const fields = arguments[0];
      const msg = arguments[1];
      this._log(LogLevel.debug, fields, msg, ...[...arguments].splice(2));
    }
  }
  info(fields: object, msg: string, ...args: any[]): void;
  info(msg: string, ...args: any[]): void;
  info(): void {
    if (typeof arguments[0] === 'string') {
      const fields = {};
      const msg = arguments[0];
      this._log(LogLevel.info, fields, msg, ...[...arguments].splice(1));
    } else {
      const fields = arguments[0];
      const msg = arguments[1];
      this._log(LogLevel.info, fields, msg, ...[...arguments].splice(2));
    }
  }
  warn(fields: object, msg: string, ...args: any[]): void;
  warn(msg: string, ...args: any[]): void;
  warn(): void {
    if (typeof arguments[0] === 'string') {
      const fields = {};
      const msg = arguments[0];
      this._log(LogLevel.warn, fields, msg, ...[...arguments].splice(1));
    } else {
      const fields = arguments[0];
      const msg = arguments[1];
      this._log(LogLevel.warn, fields, msg, ...[...arguments].splice(2));
    }
  }
  error(fields: object, msg: string, ...args: any[]): void;
  error(msg: string, ...args: any[]): void;
  error(): void {
    if (typeof arguments[0] === 'string') {
      const fields = {};
      const msg = arguments[0];
      this._log(LogLevel.error, fields, msg, ...[...arguments].splice(1));
    } else {
      const fields = arguments[0];
      const msg = arguments[1];
      this._log(LogLevel.error, fields, msg, ...[...arguments].splice(2));
    }
  }
  fatal(fields: object, msg: string, ...args: any[]): void;
  fatal(msg: string, ...args: any[]): void;
  fatal(): void {
    if (typeof arguments[0] === 'string') {
      const fields = {};
      const msg = arguments[0];
      this._log(LogLevel.fatal, fields, msg, ...[...arguments].splice(1));
    } else {
      const fields = arguments[0];
      const msg = arguments[1];
      this._log(LogLevel.fatal, fields, msg, ...[...arguments].splice(2));
    }
  }
}
